import React from 'react';
import { Box, Typography, Chip, Fade } from '@mui/material';
import { DocumentScanner, PictureAsPdf, Description } from '@mui/icons-material';

interface DocumentProcessingSectionProps {
  showDocumentProcessing: boolean;
  documentProcessingText: string;
  currentProcessingPhase?: string;
}

export const DocumentProcessingSection: React.FC<DocumentProcessingSectionProps> = ({ 
  showDocumentProcessing, 
  documentProcessingText,
  currentProcessingPhase
}) => {
  if (!showDocumentProcessing || !documentProcessingText) return null;

  // Choose icon based on processing text content
  const getProcessingIcon = () => {
    if (documentProcessingText.toLowerCase().includes('pdf')) {
      return <PictureAsPdf sx={{ color: '#dc2626', fontSize: '1.25rem' }} />;
    } else if (documentProcessingText.toLowerCase().includes('docx') || documentProcessingText.toLowerCase().includes('word')) {
      return <Description sx={{ color: '#2563eb', fontSize: '1.25rem' }} />;
    }
    return <DocumentScanner sx={{ color: '#059669', fontSize: '1.25rem' }} />;
  };

  return (
    <Fade in={showDocumentProcessing} timeout={500}>
      <Box sx={{ 
        mt: 2, 
        p: 2, 
        bgcolor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 2,
        border: '1px solid rgba(148, 163, 184, 0.18)',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          {getProcessingIcon()}
          <Typography 
            variant="subtitle2" 
            sx={{ 
              color: '#e5eef8', 
              fontWeight: 600,
              fontSize: '0.875rem'
            }}
          >
            Document Processing
          </Typography>
          <Chip
            label="Live"
            size="small"
            sx={{
              backgroundColor: 'rgba(34, 197, 94, 0.14)',
              color: '#86efac',
              fontWeight: 500,
              fontSize: '0.65rem',
              height: 18,
              border: '1px solid #bbf7d0'
            }}
          />
          {currentProcessingPhase && (
            <Chip
              label={currentProcessingPhase}
              size="small"
              variant="outlined"
              sx={{
                color: 'rgba(191, 219, 254, 0.72)',
                borderColor: 'rgba(148, 163, 184, 0.28)',
                fontSize: '0.65rem',
                height: 18
              }}
            />
          )}
        </Box>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgba(226, 232, 240, 0.82)', 
            fontSize: '0.8rem',
            lineHeight: 1.5,
            backgroundColor: 'rgba(2, 8, 23, 0.34)',
            p: 1.5,
            borderRadius: 1.5,
            border: '1px solid rgba(148, 163, 184, 0.14)'
          }}
        >
          {documentProcessingText}
        </Typography>
      </Box>
    </Fade>
  );
}; 